import { render, staticRenderFns } from "./view_contact.vue?vue&type=template&id=af0c9a7e&scoped=true"
import script from "./view_contact.vue?vue&type=script&lang=js"
export * from "./view_contact.vue?vue&type=script&lang=js"
import style0 from "./view_contact.vue?vue&type=style&index=0&id=af0c9a7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0c9a7e",
  null
  
)

export default component.exports